/* Main theme scripts
========================================================================== */

(function($){

"use strict";

// init form select2
if ( $('.form-select2').length ) {
	$('.form-select2 select').each(function() {
		$(this).select2({
			width: 'auto',
			minimumResultsForSearch: -1,
			dropdownAutoWidth: true
		});
	});
}

// has contact form
if ( $('form.wpcf7-form').length ) {
	$('body').addClass('has-contact-form');
}

// verification modal
if (
	$('#verification-modal').length &&
	(typeof FERRER_VER_POPUP !== 'undefined')
) {
	if ( ! $.cookie(FERRER_VER_POPUP.cookieName) ) {
		$('#verification-modal').modal();
	}

	$('#yes-button').on('click', function(e) {
		$.cookie(FERRER_VER_POPUP.cookieName, 'true', { expires: 30, path: '/' });
		$('#verification-modal').modal('hide');

		if (
			typeof FERRER_CONTEST_POPUP !== 'undefined' &&
			! $.cookie(FERRER_CONTEST_POPUP.cookieName)
		) {
			setTimeout(function() {
				$('#contest-modal').modal();
			}, 1000);
		}
	});

	$('#no-button').on('click', function(e) {
		window.location.href = $(this).data('url');
	});

	$('#no-button-close').on('click', function(e) {
		$.cookie(FERRER_VER_POPUP.cookieName, 'false', { expires: 30, path: '/' });

		if ( FERRER_VER_POPUP.patientUrl ) {
			window.location.href = FERRER_VER_POPUP.patientUrl;
		} else {
			$('#verification-modal').modal('hide');
		}
	});
}

// form modal
if (
	$('#form-modal').length &&
	(typeof FERRER_FORM_POPUP !== 'undefined')
) {
	document.addEventListener('wpcf7mailsent', function(e) {
		if ( e.detail.contactFormId == FERRER_FORM_POPUP.contactFormId ) {
			$('#form-modal').modal();
		}
	}, false);
}

// card loop
if ( $('.sb-card-loop').length ) {
	$('.sb-card-loop .slick-carousel').slick({
		slidesToShow: 3,
		arrows: false,
		dots: false,
		infinite: false,
		responsive: [
			{
			  breakpoint: 992,
			  settings: {
				slidesToShow: 2,
				dots: true
			  }
			},
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 1,
				dots: true
			  }
			}
		]
	});

	// Hide the expand arrow when the text fits within the card (no clamp needed).
	// Responsive: re-evaluated on load/resize since the card width changes per breakpoint.
	var toggleCardExpand = function() {
		$('.sb-card-loop .card').each(function() {
			var $card = $(this),
				$collapse = $card.find('.collapse');

			if ( ! $collapse.length || $collapse.hasClass('show') ) {
				return;
			}

			// Re-apply the clamp so we always measure against the collapsed state.
			$card.addClass('read-more');

			var clampedHeight = $collapse.outerHeight(),
				fullHeight = $collapse.prop('scrollHeight');

			// Content fits within the clamp: the expand arrow isn't necessary.
			if ( fullHeight <= clampedHeight + 1 ) {
				$card.removeClass('read-more');
			}
		});
	};

	toggleCardExpand();

	$(window).on('load', toggleCardExpand);
	$(window).on('resize', toggleCardExpand);
}

// post loop
if ( $('.sb-post-loop').length ) {
	$('.sb-post-loop .slick-carousel').slick({
		slidesToShow: 4,
		arrows: false,
		dots: false,
		infinite: false,
		responsive: [
			{
			  breakpoint: 992,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: true
			  }
			},
			{
			  breakpoint: 576,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				dots: true
			  }
			}
		]
	});
}

// category loop
if ( $('.sb-category-loop').length ) {
	$('.sb-category-loop .slick-carousel').each(function() {
		var $nav = $(this).siblings('.category-nav');

		$(this).slick({
			slidesToShow: 4,
			arrows: true,
			prevArrow: $nav.find('.category-nav-prev'),
			nextArrow: $nav.find('.category-nav-next'),
			dots: false,
			infinite: false,
			responsive: [
				{
				  breakpoint: 992,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				  }
				}
			]
		});
	});
}

// resource history: video views and progress, only with a Ferrer Connect session
if (
	typeof FERRER_HISTORY !== 'undefined' &&
	typeof Vimeo !== 'undefined'
) {
	var saveHistory = function(data) {
		$.ajax({
			url: FERRER_HISTORY.url,
			method: 'POST',
			data: data,
			headers: { 'X-WP-Nonce': FERRER_HISTORY.nonce }
		});
	};

	var savePosition = function(state) {
		if ( state.duration ) {
			saveHistory({ resource: state.resource, position: Math.floor(state.seconds), duration: Math.floor(state.duration) });
		}
	};

	$(document).on('afterShow.fb', function(e, instance, slide) {
		var $orig = slide.opts.$orig,
			iframe = slide.$slide.find('iframe')[0];

		if ( !$orig || !$orig.data('resource') || !iframe || slide.history ) {
			return;
		}

		var player = new Vimeo.Player(iframe),
			resume = parseInt($orig.data('resume'), 10) || 0,
			state = slide.history = { resource: $orig.data('resource'), seconds: 0, duration: 0, saved: 0 };

		// On the resource page the page load already counted the view.
		saveHistory({ resource: state.resource, view: $('body').hasClass('single-resource') ? 0 : 1 });

		if ( resume ) {
			player.setCurrentTime(resume);
		}

		player.on('timeupdate', function(data) {
			state.seconds = data.seconds;
			state.duration = data.duration;

			if ( Math.abs(state.seconds - state.saved) >= 15 ) {
				state.saved = state.seconds;
				savePosition(state);
			}
		});

		player.on('pause', function() {
			savePosition(state);
		});

		player.on('ended', function() {
			state.seconds = state.duration;
			savePosition(state);
		});
	});

	// The player is removed with the popup, so save the last known position.
	$(document).on('beforeClose.fb', function(e, instance) {
		var slide = instance.current;

		if ( slide && slide.history ) {
			savePosition(slide.history);
		}
	});
}

// jpages
var jpagesContainer = function() {
	var $container = $('#jpages-container'),
		postsPerPage = $container.data('page');

	$('div.holder').jPages({
		containerID : "jpages-container",
		previous: '',
		next: '',
		minHeight: false,
		perPage: postsPerPage,
		midRange: 3,
		callback: function(pages, items) {
			$('div.holder, .holder a.jp-previous, .holder a.jp-next').removeClass('jp-invisible');

			if ( postsPerPage >= items.count  ) {
				$('div.holder').addClass('jp-invisible');
			}

			if ( pages.current == 1 ) {
				$('.holder a.jp-previous').addClass('jp-invisible');
			}

			if ( pages.count == pages.current ) {
				$('.holder a.jp-next').addClass('jp-invisible');
			}
		}
	});
};

if ( $('#jpages-container').length ) {
	jpagesContainer();
}

// filters
if ( $('.filter-button-group').length ) {
	$('.filter-button-group .nav-link').on('click', function(e) {
		var $link = $(this),
			filter = $link.data('filter');

		$('.filter-button-group .nav-link').removeClass('active');
		$link.addClass('active');

		if ( $('#jpages-container').length ) {
			$('div.holder').jPages('destroy');
		}

		if ( $('.grid .element-item .accordion-button').length ) {
			$('.grid .element-item .accordion-button:not(.collapsed)').trigger('click');
		}

		if ( filter == '*' ) {
			$('.grid .element-item').show();

		} else {
			$('.grid .element-item').hide();

			$('.grid .element-item').each(function() {
				var $term = $(this),
					classes = $term.prop('classList');

				classes.forEach(function(item) {
					if ( item == filter ) {
						$term.show();
					}
				});
			});
		}

		if ( $('#jpages-container').length ) {
			jpagesContainer();
		}
	});
}

// resource sections: one section visible at a time, selectable by hash (#slug)
if ( $('[data-resource-sections]').length ) {
	var $resourceSections = $('[data-resource-sections]'),
		$resourceTabs = $resourceSections.find('.resource-tab'),
		$resourcePanels = $resourceSections.find('.resource-panel');

	var showResourceSection = function(slug, scroll) {
		var $tab = $resourceTabs.filter(function() {
			return $(this).data('section') === slug;
		});

		if ( ! slug || ! $tab.length ) {
			return false;
		}

		$resourceTabs.removeClass('active').attr('aria-current', 'false');
		$tab.addClass('active').attr('aria-current', 'true');

		$resourcePanels.attr('hidden', true).filter(function() {
			return $(this).data('section') === slug;
		}).removeAttr('hidden');

		if ( scroll ) {
			var navbarHeight = $('#main-nav').outerHeight() || 0,
				topbarHeight = $('.site-topbar').outerHeight() || 0;

			$('html, body').animate({
				scrollTop: $resourceSections.offset().top - navbarHeight - topbarHeight - 20
			}, 400);
		}

		return true;
	};

	var currentHash = decodeURIComponent( window.location.hash.substring(1) );

	if ( ! showResourceSection(currentHash, true) ) {
		showResourceSection($resourceTabs.first().data('section'), false);
	}

	$resourceTabs.on('click', function(e) {
		e.preventDefault();

		var slug = $(this).data('section');

		showResourceSection(slug, false);

		if ( window.history.replaceState ) {
			window.history.replaceState(null, '', '#' + slug);
		}
	});

	// Links from the menu dropdown to the same page only change the hash.
	$(window).on('hashchange', function() {
		showResourceSection(decodeURIComponent( window.location.hash.substring(1) ), true);
	});
}

// nav dropdowns: on desktop they open on hover, so the parent link goes to its page
$('#main-nav .dropdown > .dropdown-toggle').on('click', function(e) {
	var href = $(this).attr('href');

	if ( $(window).width() >= 992 && href && href !== '#' ) {
		window.location.href = href;
	}
});

// navbar shadow
if ( $('#main-nav-dev').length ) {
	window.addEventListener('DOMContentLoaded', event => {
		var navbarShadow = function() {
			const navbarCollapsible = document.body.querySelector('#main-nav');

			if ( !navbarCollapsible ) {
				return;
			}

			if ( window.scrollY === 0 ) {
				navbarCollapsible.classList.remove('shadow-sm')

			} else {
				navbarCollapsible.classList.add('shadow-sm')
			}
		};

		navbarShadow();

		document.addEventListener('scroll', navbarShadow);
	});
}

// position topbar
positionTopbar();

$(window).resize(function () {
	positionTopbar();
});

// smooth scrolling for hash links
if ( $('.sidebar-navigation').length ) {
	$('.sidebar-navigation .nav-link[href^="#"]').on('click', function(e) {
		e.preventDefault();

		var target = $(this).attr('href'),
			$target = $(target),
			dataOffset = parseInt($(this).data('offset')) || 0;

		if ( $target.length ) {
			var offsetTop = $target.offset().top,
				navbarHeight = $('#main-nav').outerHeight() || 0,
				adminBarHeight = $('.admin-bar .site-header .navbar').css('top');

			adminBarHeight = adminBarHeight ? parseInt(adminBarHeight) : 0;

			// Calculate final scroll position
			var scrollPosition = offsetTop - navbarHeight - adminBarHeight - 20 - dataOffset;

			$('html, body').animate({
				scrollTop: scrollPosition
			}, 800);

			// Update active state
			$('.sidebar-navigation .nav-link').removeClass('active');
			$(this).addClass('active');
		}
	});
}

// Fixed sidebar functionality
if ( $('.entry-sidebar').length ) {
	var $sidebar = $('.entry-sidebar .sidebar-item'),
		sidebarOffset = $sidebar.offset().top,
		sidebarHeight = $sidebar.outerHeight(),
		navbarHeight = $('#main-nav').outerHeight() || 0,
		siteTopbar = $('.site-topbar').outerHeight() || 0,
		adminBarHeight = $('.admin-bar .site-header .navbar').css('top'),
		adminBarHeight = adminBarHeight ? parseInt(adminBarHeight) : 0,
		topOffset = navbarHeight + siteTopbar + adminBarHeight + 20,
		$entryItems = $('.entry-items');

	if ( $(window).width() >= 992 ) {
		$(window).on('scroll', function() {
			var scrollTop = $(window).scrollTop();

			// Check if sidebar should be fixed
			if ( scrollTop > sidebarOffset - topOffset ) {
				$sidebar.addClass('sidebar-fixed');
			} else {
				$sidebar.removeClass('sidebar-fixed');
			}

			// Check if we've scrolled past the content area
			if ( $entryItems.length ) {
				var entryItemsBottom = $entryItems.offset().top + $entryItems.outerHeight();
				var sidebarBottom = scrollTop + topOffset + sidebarHeight;

				if ( sidebarBottom > entryItemsBottom ) {
					$sidebar.addClass('sidebar-fixed');
					$sidebar.css('top', entryItemsBottom - sidebarHeight - scrollTop + 'px');
				} else {
					$sidebar.css('top', topOffset + 'px');
				}
			}
		});
	}

	// Handle window resize
	$(window).on('resize', function() {
		if ( $(window).width() < 992 ) {
			$sidebar.removeClass('sidebar-fixed').css('top', '');
		} else {
			sidebarOffset = $sidebar.offset().top;
			sidebarHeight = $sidebar.outerHeight();
		}
	});
}

})(jQuery);

/*----------  Site functions  ----------*/

function positionTopbar() {
	if ( jQuery('.site-topbar').length ) {
		var nav_height = jQuery('#main-nav').outerHeight(),
			bar_height = jQuery('.site-topbar').outerHeight(),
			adminbar_height = jQuery('.admin-bar .site-header .navbar').css('top');

		nav_height = nav_height ? nav_height : 0;
		bar_height = bar_height ? bar_height : 0;
		adminbar_height = adminbar_height ? parseInt(adminbar_height) : 0;

		// inner-block omits admin bar height (already offset by WP's html margin-top).
		var site_topbar_val = Math.round(nav_height + adminbar_height) + 'px',
			inner_block_val = Math.round(nav_height + bar_height) + 'px';

		jQuery('.site-topbar').css('top', site_topbar_val);

		jQuery('.inner-block').css('padding-top', inner_block_val);
	}
}
